import { Box, Card, List, ListItem, ListItemSecondaryAction, ListItemText, Typography } from '@material-ui/core';
import React from 'react';
import Currency from '../../../commonModules/Currency';
import { reconciledAmount } from '../../../../../../jsx/utils/factId5000';
import { useCurrency } from '../../../../../../jsx/hooks/useCurrency';

// Composant fonctionnel — il n'a pas d'état, et la devise du compte n'est accessible
// que par un hook.
function IncomeDetails({ income }) {
    // Les montants sont stockés dans la devise du compte : sans cette indication, Currency
    // les libellerait en FCFA, ce qui est faux pour les comptes en Euro ou en dollar.
    const currency = useCurrency() || 'FCFA';
    // Montant déjà rapproché avec des ventes 8000.
    const pointed = reconciledAmount(income.income_amount, income.income_total_available);

    return (
            <Card >
                <Box p={1}>
                    <List>
                        <ListItem>
                            <ListItemText
                                primary={
                                    <Typography variant="h6">Reste à pointer:</Typography>
                                }
                            />
                            <ListItemSecondaryAction>
                                <ListItemText
                                    color="secondary"
                                    primary={
                                        <Typography color="secondary" variant="subtitle1">
                                            <Currency value={income.income_total_available} sourceCurrency={currency} />
                                        </Typography>
                                    }
                                />
                            </ListItemSecondaryAction>
                        </ListItem>
                        {pointed !== null &&
                            <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Montant pointé:</Typography>
                                    }
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText
                                        primary={
                                            <Typography variant="subtitle1">
                                                <Currency value={pointed} sourceCurrency={currency} />
                                            </Typography>
                                        }
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                        }
                        <ListItem>
                            <ListItemText
                                primary={
                                    <Typography >Montant total:</Typography>
                                }
                            />
                            <ListItemSecondaryAction>
                                <ListItemText
                                    color="secondary"
                                    primary={
                                        <Typography variant="subtitle1">
                                            <Currency value={income.income_amount} sourceCurrency={currency} />
                                        </Typography>
                                    }
                                />
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem>
                            <ListItemText
                                primary={
                                    <Typography>Date encaissement:</Typography>
                                }
                            />
                            <ListItemSecondaryAction>
                                <ListItemText
                                    primary={new Date(income.income_date).toLocaleDateString("fr-FR")}
                                />
                            </ListItemSecondaryAction>
                        </ListItem>

                        <ListItem>
                            <ListItemText
                                primary={
                                    <Typography>Banque:</Typography>
                                }
                            />
                            <ListItemSecondaryAction>
                                <ListItemText primary={income.income_bank} />
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem>
                            <ListItemText
                                primary={
                                    <Typography>Poste:</Typography>
                                }
                            />
                            <ListItemSecondaryAction>
                                <ListItemText primary={income.income_post} />
                            </ListItemSecondaryAction>
                        </ListItem>
                    </List>
                    <Box p={1}>
                        <Typography variant="caption">{income.income_desc}</Typography>
                    </Box>
                </Box>
            </Card>
    );
}

export default IncomeDetails;
